/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { OrderItem } from './OrderItem.js';
import {
    OrderItemFromJSON,
    OrderItemFromJSONTyped,
    OrderItemToJSON,
} from './OrderItem.js';

/**
 * 
 * @export
 * @interface Order
 */
export interface Order {
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    brandName?: string;
    /**
     * 
     * @type {Array<OrderItem>}
     * @memberof Order
     */
    items?: Array<OrderItem>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Order
     */
    metadata?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    customerName?: string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    customerId?: string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    agentOfRecordName?: string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    agentOfRecordId?: string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    status?: string;
    /**
     * 
     * @type {Date}
     * @memberof Order
     */
    dateCreated?: Date;
}

/**
 * Check if a given object implements the Order interface.
 */
export function instanceOfOrder(value: object): boolean {
    return true;
}

export function OrderFromJSON(json: any): Order {
    return OrderFromJSONTyped(json, false);
}

export function OrderFromJSONTyped(json: any, ignoreDiscriminator: boolean): Order {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'description': json['description'] == null ? undefined : json['description'],
        'brandName': json['brandName'] == null ? undefined : json['brandName'],
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(OrderItemFromJSON)),
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
        'customerName': json['customerName'] == null ? undefined : json['customerName'],
        'customerId': json['customerId'] == null ? undefined : json['customerId'],
        'agentOfRecordName': json['agentOfRecordName'] == null ? undefined : json['agentOfRecordName'],
        'agentOfRecordId': json['agentOfRecordId'] == null ? undefined : json['agentOfRecordId'],
        'status': json['status'] == null ? undefined : json['status'],
        'dateCreated': json['dateCreated'] == null ? undefined : (new Date(json['dateCreated'])),
    };
}

export function OrderToJSON(value?: Order | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'description': value['description'],
        'brandName': value['brandName'],
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(OrderItemToJSON)),
        'metadata': value['metadata'],
        'customerName': value['customerName'],
        'customerId': value['customerId'],
        'agentOfRecordName': value['agentOfRecordName'],
        'agentOfRecordId': value['agentOfRecordId'],
        'status': value['status'],
        'dateCreated': value['dateCreated'] == null ? undefined : ((value['dateCreated']).toISOString()),
    };
}

